export default __webpack_public_path__ + "static/screenshot_5-87e07c5606be04d82f4fda8ec437d9ab.png";